import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BarChart from '@/features/reports/components/chartjs/BarChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '@/features/reports/components/ChartError.vue';
import ChartLabels from '@/features/reports/components/ChartLabels.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { Data, SeriesConfig } from '@/features/reports/models';
import { computed, PropType } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';
import Report from '@/features/reports/components/Report.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProactiveTriggersTrendChart',
  props: {
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { reportId, isDataEmpty, isDataLoaded, createBlankSeries } = useReportData(props);

const seriesOrder: SeriesConfig[] = [
  { name: 'Started', displayName: 'Proactive Triggers Started', colour: '#062B80' },
  { name: 'Blocked', displayName: 'Proactive Triggers Blocked', colour: '#FF6666' },
];

const reportData = computed<Data>(() => ({
  scale: props.data.scale,
  series: seriesOrder.map((seriesConfig) => {
    return (
      props.data.series.find((s) => s.name === seriesConfig.name) ||
      createBlankSeries(seriesConfig.name, seriesConfig.displayName)
    );
  }),
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: "Proactive Triggers",
    "tooltip-text": "A trend showing the number of proactive flows that were started and the number that were blocked from starting due to the monthly limit being reached.",
    class: "chart-container",
    "data-empty": _unref(isDataEmpty),
    "loaded-data": _unref(isDataLoaded),
    "loading-error": __props.loadingError
  }, {
    chart: _withCtx(() => [
      _createVNode(BarChart, {
        reportId: _unref(reportId),
        class: "chart",
        data: reportData.value,
        seriesOrder: seriesOrder,
        stacked: true
      }, null, 8, ["reportId", "data"])
    ]),
    _: 1
  }, 8, ["report-id", "data-empty", "loaded-data", "loading-error"]))
}
}

})